export default function dateWithoutTimeZone(date) {
    if (date == null) return date;
    date = new Date( date );
    var timestamp = date.getTime() + date.getTimezoneOffset() * 60000;
    var correctDate = new Date(timestamp);
    return correctDate;
}